export { default } from './DangerButton';
export type { DangerButtonProps } from './DangerButton';
